import Http from "../engine/Http";
import { Identifiable } from "../model/Items";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

export interface Material extends Identifiable {
  name: string;
  density: number;
  unitPrice: number;
  kilogramPrice? : number;
}

const useMaterialApi = () => {
  const authenticationHeader = useAuthenticationHeader();
  const fetchMaterials = (): Promise<Material[]> => Http.get('api/materials', [ authenticationHeader ]);

  return {
    fetchMaterials
  };
};

export default useMaterialApi;